import { UserIdentityProvider } from "@core/services/user-identity.context";
import Activity from "@domain/activity/activity";
import EditActivity from "@domain/activity/edit-activity/edit-activity";
import ListActivity from "@domain/activity/list-activity/list-activity";
import NewActivity from "@domain/activity/new-activity/new-activity";
import Agent from "@domain/agent/agent";
import EditAgent from "@domain/agent/edit-agent/edit-agent";
import ListAgent from "@domain/agent/list-agent/list-agent";
import NewAgent from "@domain/agent/new-agent/new-agent";
import Client from "@domain/client/client";
import EditClient from "@domain/client/edit-client/edit-client";
import ListClient from "@domain/client/list-client/list-client";
import NewClient from "@domain/client/new-client/new-client";
import Dashboard from "@domain/dashboard/dashboard";
import EditHotel from "@domain/hotel/edit-hotel/edit-hotel";
import Hotel from "@domain/hotel/hotel";
import ListHotel from "@domain/hotel/list-hotel/list-hotel";
import NewHotel from "@domain/hotel/new-hotel/new-hotel";
import EditInvoice from "@domain/invoice/edit-invoice/edit-invoice";
import Invoice from "@domain/invoice/invoice";
import ListInvoice from "@domain/invoice/list-invoice/list-invoice";
import NewInvoice from "@domain/invoice/new-invoice/new-invoice";
import LandingPage from "@domain/landing-page/landing-page";
import EditLocation from "@domain/location/edit-location/edit-location";
import ListLocation from "@domain/location/list-location/list-location";
import Location from "@domain/location/location";
import NewLocation from "@domain/location/new-location/new-location";
import Login from "@domain/login/login";
import EditPackage from "@domain/package/edit-package/edit-package";
import ListPackage from "@domain/package/list-package/list-package";
import NewPackage from "@domain/package/new-package/new-package";
import Package from "@domain/package/package";
import EditPackageAccommodation from "@domain/package-accommodation/edit-package-accommodation/edit-package-accommodation";
import ListPackageAccommodation from "@domain/package-accommodation/list-package-accommodation/list-package-accommodation";
import NewPackageAccommodation from "@domain/package-accommodation/new-package-accommodation/new-package-accommodation";
import PackageAccommodation from "@domain/package-accommodation/package-accommodation";
import EditPackageActivity from "@domain/package-activity/edit-package-activity/edit-package-activity";
import ListPackageActivity from "@domain/package-activity/list-package-activity/list-package-activity";
import NewPackageActivity from "@domain/package-activity/new-package-activity/new-package-activity";
import PackageActivity from "@domain/package-activity/package-activity";
import EditPackageTransport from "@domain/package-transport/edit-package-transport/edit-package-transport";
import ListPackageTransport from "@domain/package-transport/list-package-transport/list-package-transport";
import NewPackageTransport from "@domain/package-transport/new-package-transport/new-package-transport";
import PackageTransport from "@domain/package-transport/package-transport";
import RouteErrorBoundary from "@domain/page-error/route-error-boundary";
import EditPayment from "@domain/payment/edit-payment/edit-payment";
import ListPayment from "@domain/payment/list-payment/list-payment";
import NewPayment from "@domain/payment/new-payment/new-payment";
import Payment from "@domain/payment/payment";
import EditPerson from "@domain/person/edit-person/edit-person";
import ListPerson from "@domain/person/list-person/list-person";
import NewPerson from "@domain/person/new-person/new-person";
import Person from "@domain/person/person";
import Public from "@domain/public/public";
import EditQuotation from "@domain/quotation/edit-quotation/edit-quotation";
import ListQuotation from "@domain/quotation/list-quotation/list-quotation";
import NewQuotation from "@domain/quotation/new-quotation/new-quotation";
import Quotation from "@domain/quotation/quotation";
import EditQuoteAccommodation from "@domain/quote-accommodation/edit-quote-accommodation/edit-quote-accommodation";
import ListQuoteAccommodation from "@domain/quote-accommodation/list-quote-accommodation/list-quote-accommodation";
import NewQuoteAccommodation from "@domain/quote-accommodation/new-quote-accommodation/new-quote-accommodation";
import QuoteAccommodation from "@domain/quote-accommodation/quote-accommodation";
import EditQuoteActivity from "@domain/quote-activity/edit-quote-activity/edit-quote-activity";
import ListQuoteActivity from "@domain/quote-activity/list-quote-activity/list-quote-activity";
import NewQuoteActivity from "@domain/quote-activity/new-quote-activity/new-quote-activity";
import QuoteActivity from "@domain/quote-activity/quote-activity";
import EditQuoteTransport from "@domain/quote-transport/edit-quote-transport/edit-quote-transport";
import ListQuoteTransport from "@domain/quote-transport/list-quote-transport/list-quote-transport";
import NewQuoteTransport from "@domain/quote-transport/new-quote-transport/new-quote-transport";
import QuoteTransport from "@domain/quote-transport/quote-transport";
import EditRatePerPax from "@domain/rate-per-pax/edit-rate-per-pax/edit-rate-per-pax";
import ListRatePerPax from "@domain/rate-per-pax/list-rate-per-pax/list-rate-per-pax";
import NewRatePerPax from "@domain/rate-per-pax/new-rate-per-pax/new-rate-per-pax";
import RatePerPax from "@domain/rate-per-pax/rate-per-pax";
import EditRole from "@domain/role/edit-role/edit-role";
import ListRole from "@domain/role/list-role/list-role";
import NewRole from "@domain/role/new-role/new-role";
import Role from "@domain/role/role";
import EditRoomType from "@domain/room-type/edit-room-type/edit-room-type";
import ListRoomType from "@domain/room-type/list-room-type/list-room-type";
import NewRoomType from "@domain/room-type/new-room-type/new-room-type";
import RoomType from "@domain/room-type/room-type";
import AuthShell from "@domain/shell/auth-shell/auth-shell";
import CustomerAuthShell from "@domain/shell/customer-auth-shell/customer-auth-shell";
import MainShell from "@domain/shell/main-shell/main-shell";
import EditStatus from "@domain/status/edit-status/edit-status";
import ListStatus from "@domain/status/list-status/list-status";
import NewStatus from "@domain/status/new-status/new-status";
import Status from "@domain/status/status";
import EditTenant from "@domain/tenant/edit-tenant/edit-tenant";
import ListTenant from "@domain/tenant/list-tenant/list-tenant";
import NewTenant from "@domain/tenant/new-tenant/new-tenant";
import Tenant from "@domain/tenant/tenant";
import EditTransportType from "@domain/transport-type/edit-transport-type/edit-transport-type";
import ListTransportType from "@domain/transport-type/list-transport-type/list-transport-type";
import NewTransportType from "@domain/transport-type/new-transport-type/new-transport-type";
import TransportType from "@domain/transport-type/transport-type";
import EditTravelVoucher from "@domain/travel-voucher/edit-travel-voucher/edit-travel-voucher";
import ListTravelVoucher from "@domain/travel-voucher/list-travel-voucher/list-travel-voucher";
import NewTravelVoucher from "@domain/travel-voucher/new-travel-voucher/new-travel-voucher";
import TravelVoucher from "@domain/travel-voucher/travel-voucher";
import EditUtilActivityType from "@domain/util-activity-type/edit-util-activity-type/edit-util-activity-type";
import ListUtilActivityType from "@domain/util-activity-type/list-util-activity-type/list-util-activity-type";
import NewUtilActivityType from "@domain/util-activity-type/new-util-activity-type/new-util-activity-type";
import UtilActivityType from "@domain/util-activity-type/util-activity-type";
import EditUtilAgeBracket from "@domain/util-age-bracket/edit-util-age-bracket/edit-util-age-bracket";
import ListUtilAgeBracket from "@domain/util-age-bracket/list-util-age-bracket/list-util-age-bracket";
import NewUtilAgeBracket from "@domain/util-age-bracket/new-util-age-bracket/new-util-age-bracket";
import UtilAgeBracket from "@domain/util-age-bracket/util-age-bracket";
import EditUtilTransportLocation from "@domain/util-transport-location/edit-util-transport-location/edit-util-transport-location";
import ListUtilTransportLocation from "@domain/util-transport-location/list-util-transport-location/list-util-transport-location";
import NewUtilTransportLocation from "@domain/util-transport-location/new-util-transport-location/new-util-transport-location";
import UtilTransportLocation from "@domain/util-transport-location/util-transport-location";
import { SessionProvider } from "@factory/authentication/session.context";
import { ProtectedRoute } from "@shared/ui/protected-route/protected-route";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import ListClientQuotation from "./domain/quotation/list-client-quotation/list-client-quotation";
import QuotationUtilsShell from "./domain/quotation-utils-shell/quotation-utils-shell";
// ROUTE IMPORT

const tenant = {
  path: "tenant",
  element: <Tenant />,
  children: [
    {
      path: "",
      element: <ListTenant />,
    },
    {
      path: "new",
      element: <NewTenant />,
    },
    {
      path: ":tenantId",
      element: <EditTenant />,
    },
  ],
};
const role = {
  path: "role",
  element: <Role />,
  children: [
    {
      path: "",
      element: <ListRole />,
    },
    {
      path: "new",
      element: <NewRole />,
    },
    {
      path: ":roleId",
      element: <EditRole />,
    },
  ],
};
const account = {
  path: "account",
  element: <Person />,
  children: [
    {
      path: "",
      element: <ListPerson />,
    },
    {
      path: "new",
      element: <NewPerson />,
    },
    {
      path: ":personId",
      element: <EditPerson />,
    },
  ],
};
const utilAgeBracket = {
  path: "util-age-bracket",
  element: <UtilAgeBracket />,
  children: [
    {
      path: "",
      element: <ListUtilAgeBracket />,
    },
    {
      path: "new",
      element: <NewUtilAgeBracket />,
    },
    {
      path: ":utilAgeBracketId",
      element: <EditUtilAgeBracket />,
    },
  ],
};
const transportType = {
  path: "util-transport-type",
  element: <TransportType />,
  children: [
    {
      path: "",
      element: <ListTransportType />,
    },
    {
      path: "new",
      element: <NewTransportType />,
    },
    {
      path: ":transportTypeId",
      element: <EditTransportType />,
      children: [
        {
          path: "",
          element: <UtilAgeBracket />,
          children: [
            {
              path: "",
              element: <ListUtilAgeBracket />,
            },
            {
              path: "new",
              element: <NewUtilAgeBracket />,
            },
            {
              path: ":utilAgeBracketId",
              element: <EditUtilAgeBracket />,
            },
          ],
        },
      ],
    },
  ],
};
const utilTransportLocation = {
  path: "util-transport-location",
  element: <UtilTransportLocation />,
  children: [
    {
      path: "",
      element: <ListUtilTransportLocation />,
    },
    {
      path: "new",
      element: <NewUtilTransportLocation />,
    },
    {
      path: ":utilTransportLocationId",
      element: <EditUtilTransportLocation />,
    },
  ],
};
const utilActivityType = {
  path: "util-activity-type",
  element: <UtilActivityType />,
  children: [
    {
      path: "",
      element: <ListUtilActivityType />,
    },
    {
      path: "new",
      element: <NewUtilActivityType />,
    },
    {
      path: ":utilActivityTypeId",
      element: <EditUtilActivityType />,
    },
  ],
};
const location = {
  path: "location",
  element: <Location />,
  children: [
    {
      path: "",
      element: <ListLocation />,
    },
    {
      path: "new",
      element: <NewLocation />,
    },
    {
      path: ":locationId",
      element: <EditLocation />,
    },
  ],
};
const client = {
  path: "client",
  element: <Client />,
  children: [
    {
      path: "",
      element: <ListClient />,
    },
    {
      path: "new",
      element: <NewClient />,
    },
    {
      path: ":clientId",
      element: <EditClient />,
      children: [
        {
          path: "",
          element: <ListClientQuotation />,
        },
      ],
    },
  ],
};
const agent = {
  path: "agent",
  element: <Agent />,
  children: [
    {
      path: "",
      element: <ListAgent />,
    },
    {
      path: "new",
      element: <NewAgent />,
    },
    {
      path: ":agentId",
      element: <EditAgent />,
    },
  ],
};
const roomType = {
  path: "room-type",
  element: <RoomType />,
  children: [
    {
      path: "",
      element: <ListRoomType />,
    },
    {
      path: "new",
      element: <NewRoomType />,
    },
    {
      path: ":roomTypeId",
      element: <EditRoomType />,
    },
  ],
};
const hotel = {
  path: "hotel",
  element: <Hotel />,
  children: [
    {
      path: "",
      element: <ListHotel />,
    },
    {
      path: "new",
      element: <NewHotel />,
    },
    {
      path: ":hotelId",
      element: <EditHotel />,
      children: [
        {
          path: "",
          element: <RoomType />,
          children: [
            {
              path: "",
              element: <ListRoomType />,
            },
            {
              path: "new",
              element: <NewRoomType />,
            },
            {
              path: ":roomTypeId",
              element: <EditRoomType />,
            },
          ],
        },
      ],
    },
  ],
};
const quotation = {
  path: "quotation",
  element: <Quotation />,
  children: [
    {
      path: "",
      element: <ListQuotation />,
    },
    {
      path: "new",
      element: <NewQuotation />,
    },
    {
      path: ":quotationId",
      element: <EditQuotation />,
    },
  ],
};
const ratePerPax = {
  path: "rate-per-pax",
  element: <RatePerPax />,
  children: [
    {
      path: "",
      element: <ListRatePerPax />,
    },
    {
      path: "new",
      element: <NewRatePerPax />,
    },
    {
      path: ":ratePerPaxId",
      element: <EditRatePerPax />,
    },
  ],
};
const activity = {
  path: "activity",
  element: <Activity />,
  children: [
    {
      path: "",
      element: <ListActivity />,
    },
    {
      path: "new",
      element: <NewActivity />,
    },
    {
      path: ":activityId",
      element: <EditActivity />,
      children: [
        {
          path: "",
          element: <RatePerPax />,
          children: [
            {
              path: "",
              element: <ListRatePerPax />,
            },
            {
              path: "new",
              element: <NewRatePerPax />,
            },
            {
              path: ":ratePerPaxId",
              element: <EditRatePerPax />,
            },
          ],
        },
      ],
    },
  ],
};
const packageTransport = {
  path: "package-transport",
  element: <PackageTransport />,
  children: [
    {
      path: "",
      element: <ListPackageTransport />,
    },
    {
      path: "new",
      element: <NewPackageTransport />,
    },
    {
      path: ":packageTransportId",
      element: <EditPackageTransport />,
    },
  ],
};
const packageAccommodation = {
  path: "package-accommodation",
  element: <PackageAccommodation />,
  children: [
    {
      path: "",
      element: <ListPackageAccommodation />,
    },
    {
      path: "new",
      element: <NewPackageAccommodation />,
    },
    {
      path: ":packageAccommodationId",
      element: <EditPackageAccommodation />,
    },
  ],
};
const packageActivity = {
  path: "package-activity",
  element: <PackageActivity />,
  children: [
    {
      path: "",
      element: <ListPackageActivity />,
    },
    {
      path: "new",
      element: <NewPackageActivity />,
    },
    {
      path: ":packageActivityId",
      element: <EditPackageActivity />,
    },
  ],
};
const activity_package = {
  path: "package",
  element: <Package />,
  children: [
    {
      path: "",
      element: <ListPackage />,
    },
    {
      path: "new",
      element: <NewPackage />,
    },
    {
      path: ":packageId",
      element: <EditPackage />,
      children: [
        {
          path: "",
          element: <PackageActivity />,
          children: [
            {
              path: "",
              element: <ListPackageActivity />,
            },
            {
              path: "new",
              element: <NewPackageActivity />,
            },
            {
              path: ":packageActivityId",
              element: <EditPackageActivity />,
            },
          ],
        },
        {
          path: "package-transport",
          element: <PackageTransport />,
          children: [
            {
              path: "",
              element: <ListPackageTransport />,
            },
            {
              path: "new",
              element: <NewPackageTransport />,
            },
            {
              path: ":packageTransportId",
              element: <EditPackageTransport />,
            },
          ],
        },
        {
          path: "package-accommodation",
          element: <PackageAccommodation />,
          children: [
            {
              path: "",
              element: <ListPackageAccommodation />,
            },
            {
              path: "new",
              element: <NewPackageAccommodation />,
            },
            {
              path: ":packageAccommodationId",
              element: <EditPackageAccommodation />,
            },
          ],
        },
      ],
    },
  ],
};
const quoteActivity = {
  path: "quote-activity",
  element: <QuoteActivity />,
  children: [
    {
      path: "",
      element: <ListQuoteActivity />,
    },
    {
      path: "new",
      element: <NewQuoteActivity />,
    },
    {
      path: ":quoteActivityId",
      element: <EditQuoteActivity />,
    },
  ],
};
const quoteTransport = {
  path: "quote-transport",
  element: <QuoteTransport />,
  children: [
    {
      path: "",
      element: <ListQuoteTransport />,
    },
    {
      path: "new",
      element: <NewQuoteTransport />,
    },
    {
      path: ":quoteTransportId",
      element: <EditQuoteTransport />,
    },
  ],
};
const quoteAccommodation = {
  path: "quote-accommodation",
  element: <QuoteAccommodation />,
  children: [
    {
      path: "",
      element: <ListQuoteAccommodation />,
    },
    {
      path: "new",
      element: <NewQuoteAccommodation />,
    },
    {
      path: ":quoteAccommodationId",
      element: <EditQuoteAccommodation />,
    },
  ],
};
const payment = {
  path: "payment",
  element: <Payment />,
  children: [
    {
      path: "",
      element: <ListPayment />,
    },
    {
      path: "new",
      element: <NewPayment />,
    },
    {
      path: ":paymentId",
      element: <EditPayment />,
    },
  ],
};
const invoice = {
  path: "invoice",
  element: <Invoice />,
  children: [
    {
      path: "",
      element: <ListInvoice />,
    },
    {
      path: "new",
      element: <NewInvoice />,
    },
    {
      path: ":invoiceId",
      element: <EditInvoice />,
      children: [
        {
          path: "",
          element: <Payment />,
          children: [
            {
              path: "",
              element: <ListPayment />,
            },
            {
              path: "new",
              element: <NewPayment />,
            },
            {
              path: ":paymentId",
              element: <EditPayment />,
            },
          ],
        },
      ],
    },
  ],
};
const travelVoucher = {
  path: "travel-voucher",
  element: <TravelVoucher />,
  children: [
    {
      path: "",
      element: <ListTravelVoucher />,
    },
    {
      path: "new",
      element: <NewTravelVoucher />,
    },
    {
      path: ":travelVoucherId",
      element: <EditTravelVoucher />,
    },
  ],
};
const status = {
  path: "status",
  element: <Status />,
  children: [
    {
      path: "",
      element: <ListStatus />,
    },
    {
      path: "new",
      element: <NewStatus />,
    },
    {
      path: ":statusId",
      element: <EditStatus />,
    },
  ],
};
// ROUTE DEFINITION

const quotationUtils = {
  path: "quotation-utils",
  element: <QuotationUtilsShell />,
  children: [transportType, utilTransportLocation, utilActivityType],
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainShell />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: "login", element: <Login /> },
      {
        path: "public",
        element: <Public />,
        children: [
          {
            path: ":tenantSlug",
            element: <LandingPage />,
          },
        ],
      },
      {
        path: "customer",
        element: (
          <UserIdentityProvider>
            <SessionProvider>
              <ProtectedRoute>
                <CustomerAuthShell />
              </ProtectedRoute>
            </SessionProvider>
          </UserIdentityProvider>
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
          {
            path: "",
            element: <LandingPage />,
          },
        ],
      },
      {
        path: "business",
        element: (
          <UserIdentityProvider>
            <SessionProvider>
              <ProtectedRoute>
                <AuthShell />
              </ProtectedRoute>
            </SessionProvider>
          </UserIdentityProvider>
        ),
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
          tenant,
          role,
          account,
          quotationUtils,
          location,
          client,
          agent,
          hotel,
          roomType,
          activity,
          activity_package,
          quotation,
          ratePerPax,
          packageActivity,
          quoteActivity,
          quoteTransport,
          quoteAccommodation,
          invoice,
          travelVoucher,
          payment,
          packageTransport,
          packageAccommodation,
          status,
          utilAgeBracket,
          // ROUTE ADD
        ],
      },
    ],
  },
]);
export function AppRoute() {
  return <RouterProvider router={router} />;
}
